function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _tagged_template_literal([
        "\n      <html>\n        <head>\n          <title>",
        '</title>\n          <meta name="description" content="rune" />\n        </head>\n        <body>\n          ',
        "\n        </body>\n      </html>\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { html, VirtualView } from "./VirtualView";
export class Layout extends VirtualView {
    template(data) {
        return html(_templateObject(), data, this.page.toHtmlSSR());
    }
    constructor(data, page){
        super(data);
        _define_property(this, "page", void 0);
        _define_property(this, "_base_name", void 0);
        _define_property(this, "isLayout", void 0);
        this.page = page;
        this._base_name = "Layout";
        this.isLayout = true;
    }
}
